import { usePromotePageState } from 'src/app/pages/promote/pageContext';

import { Variant1 } from './containers/Variant1';
import { Variant2 } from './containers/Variant2';

type Props = {
	setDisplayExperiment: (displayExperiment: boolean) => void;
};

export const SavedPaymentMethods: React.FC<Props> = ({ setDisplayExperiment }) => {
	const [{ savedPaymentExperimentVariant }] = usePromotePageState();
	if (savedPaymentExperimentVariant === 'variant_1') {
		return <Variant1 />;
	}
	return <Variant2 setDisplayExperiment={setDisplayExperiment} />;
};
